import N8nIntegration from './n8n-integration';
class Export {
    constructor(n8nConfig) {
        this.savedIssues = [];
        this.n8nIntegration = new N8nIntegration(n8nConfig);
        // Defer localStorage access to avoid SSR issues
        if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
            this.savedIssues = this.loadSavedIssues();
        }
    }
    exportToJSON(issueData) {
        const json = JSON.stringify(issueData, null, 2);
        // Check if we're in a browser environment
        if (typeof window !== 'undefined' && typeof document !== 'undefined') {
            const blob = new Blob([json], { type: 'application/json' });
            const url = URL.createObjectURL(blob);
            // Create download link
            const link = document.createElement('a');
            link.href = url;
            link.download = `issue-${Date.now()}.json`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            // Clean up
            URL.revokeObjectURL(url);
            // Save to localStorage
            this.saveIssue(issueData);
        }
        return json;
    }
    saveIssue(issueData) {
        // Check if we're in a browser environment
        if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
            return;
        }
        try {
            this.savedIssues.push({
                ...issueData,
                savedAt: new Date().toISOString(),
                id: Date.now()
            });
            // Keep only last 50 issues
            if (this.savedIssues.length > 50) {
                this.savedIssues = this.savedIssues.slice(-50);
            }
            localStorage.setItem('uxbert-saved-issues', JSON.stringify(this.savedIssues));
        }
        catch (e) {
            console.warn('Failed to save issue to localStorage:', e);
        }
    }
    loadSavedIssues() {
        // Check if we're in a browser environment
        if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
            return [];
        }
        try {
            const saved = localStorage.getItem('uxbert-saved-issues');
            return saved ? JSON.parse(saved) : [];
        }
        catch (e) {
            console.warn('Failed to load saved issues:', e);
            return [];
        }
    }
    getSavedIssues() {
        return this.savedIssues;
    }
    deleteSavedIssue(issueId) {
        this.savedIssues = this.savedIssues.filter(issue => issue.id !== issueId);
        // Check if we're in a browser environment
        if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
            localStorage.setItem('uxbert-saved-issues', JSON.stringify(this.savedIssues));
        }
    }
    clearSavedIssues() {
        this.savedIssues = [];
        // Check if we're in a browser environment
        if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
            localStorage.removeItem('uxbert-saved-issues');
        }
    }
    exportAllIssues() {
        // Check if we're in a browser environment
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            return;
        }
        const json = JSON.stringify(this.savedIssues, null, 2);
        const blob = new Blob([json], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `all-issues-${Date.now()}.json`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }
    // n8n Integration Methods
    /**
     * Send issue to n8n webhook
     */
    async sendToN8n(issueData) {
        const response = await this.n8nIntegration.sendToN8n(issueData);
        // Save to localStorage if n8n send was successful
        if (response.success) {
            this.saveIssue(issueData);
        }
        return response;
    }
    /**
     * Configure n8n integration
     */
    configureN8n(config) {
        this.n8nIntegration.configure(config);
    }
    /**
     * Check if n8n is enabled
     */
    isN8nEnabled() {
        return this.n8nIntegration.isEnabled();
    }
    /**
     * Test n8n connection
     */
    async testN8nConnection() {
        return this.n8nIntegration.testConnection();
    }
    /**
     * Get n8n configuration
     */
    getN8nConfig() {
        return this.n8nIntegration.getConfig();
    }
    /**
     * Enable/disable n8n integration
     */
    setN8nEnabled(enabled) {
        this.n8nIntegration.setEnabled(enabled);
    }
    /**
     * Set n8n webhook URL
     */
    setN8nWebhookUrl(url) {
        this.n8nIntegration.setWebhookUrl(url);
    }
}
export default Export;
//# sourceMappingURL=export.js.map